import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import Landingpage from '@/views/pages/LandingpageView.vue'
import Contact from '@/views/pages/info/ContactView.vue'
import License from '@/views/pages/info/LicenseView.vue'
import Accessibility from '@/views/pages/info/AccessibilityView.vue'
import Privacy from '@/views/pages/info/PrivacyView.vue'
import Faq from '@/views/pages/info/FaqView.vue'
import Dashboard from '@/views/pages/DashboardView.vue'
import Wallpage from '@/views/pages/WallpageView.vue'
import Login from '@/views/login/LoginView.vue'
import LTIView from '@/views/pages/LTIView.vue'

import NotFound from '@/views/status/NotFound.vue'
import Denied from '@/views/status/Denied.vue'

import useParcelStore from '@/composables/parcel'

import useApiStore from '@/composables/api'

import { useUserStore } from '@/composables/userStore'

const userStore = useUserStore()
const parcelStore = useParcelStore()
const apiStore = useApiStore()

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Landing',
    component: Landingpage,
  },
  { path: '/kontakt', name: 'Contact', component: Contact },
  { path: '/lisens', name: 'License', component: License },
  { path: '/tilgjengelighet', name: 'Accessibility', component: Accessibility },
  { path: '/personvern', name: 'Privacy', component: Privacy },
  { path: '/sporsmal', name: 'Faq', component: Faq },
  {
    path: '/dashboard',
    props: true,
    name: 'Dashboard',
    component: Dashboard,
  },
  {
    path: '/wall',
    name: 'Wall',
    component: Wallpage,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/lti',
    name: 'LTIView',
    component: LTIView,
  },
  { path: '/postlogin/:key/:value', redirect: '/dashboard/:key/:value' },
  { path: '/postlogin', redirect: '/dashboard' },
  { path: '/postlogin/lti', redirect: (to) => ({ path: '/lti', query: to.query }) },
  {
    path: '/401',
    name: 'Denied',
    component: Denied,
  },
  {
    path: '/404',
    name: 'NotFound',
    component: NotFound,
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior: (to, from, savedPosition) => savedPosition || { top: 0 },
})

router.beforeEach(async (to) => {
  const connected = apiStore.base.isConnected()
  if (!routes.some((route) => route.name === to.name || route.path.includes(to.path)) && !['404', 'auth'].some((route) => to.path.includes(route))) {
    // no route matches
    router.push('/404')
  } else if (to.path === '/' && !connected) {
    if (userStore.getters.user.value) await parcelStore.actions.unSubscribeTopic(userStore.getters.user.value._id)
    await parcelStore.actions.closeMQTTConnection()
    userStore.actions.reset()
  }
})

export default router
